<template>
  <router-view />
</template>
<script>
export default {
  name: 'PaymentsView',
}
</script>
